var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCherryGame = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31571_59850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.92188 3.72266C3.41409 3.72266 3.84763 3.58829 4.20565 3.41684C3.84218 4.10073 3.6244 4.89238 3.58118 5.70879C2.12788 5.8648 0.988281 7.08404 0.988281 8.57812C0.988281 10.1775 2.28934 11.5 3.88867 11.5C4.38139 11.5 4.85337 11.3612 5.27668 11.129C4.61998 10.4852 4.21094 9.56825 4.21094 8.57812C4.21094 7.588 4.61998 6.69254 5.27668 6.04876C4.95072 5.86992 4.59556 5.74831 4.2247 5.70107C4.36485 3.42322 6.08511 1.54434 8.30312 1.20152C7.73824 1.99459 7.43359 2.94091 7.43359 3.93448V5.7103C5.98734 5.87302 4.85547 7.08907 4.85547 8.57812C4.85547 10.1775 6.15653 11.5 7.75586 11.5C9.35519 11.5 10.6562 10.1775 10.6562 8.57812C10.6562 7.08907 9.52438 5.87302 8.07812 5.7103V3.93448C8.07812 2.8449 8.50236 1.82053 9.27277 1.05012L9.82289 0.5H9.04492C7.53128 0.5 6.15947 1.11726 5.16691 2.11292C4.90633 1.86275 4.07079 1.14453 2.92188 1.14453C1.56232 1.14453 0.632027 2.15757 0.587044 2.20071L0.34375 2.43359L0.587044 2.66648C0.632027 2.70962 1.56232 3.72266 2.92188 3.72266ZM7.75586 7.61133C7.22278 7.61133 6.78906 8.04504 6.78906 8.57812H6.14453C6.14453 7.68971 6.86745 6.9668 7.75586 6.9668V7.61133ZM3.88867 7.61133C3.35559 7.61133 2.92188 8.04504 2.92188 8.57812H2.27734C2.27734 7.68971 3.00026 6.9668 3.88867 6.9668V7.61133Z",
    fill: "#FF6E1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31571_59850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCherryGame);
export default ForwardRef;